<template>
  <div class="user-org-objs_uoo org-admin_oam" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <nav-user-orgs/>

    <div class="page-container_pcr">
      <h2 class="oam_page-title">Отчеты, аналитика организации</h2>
    </div>

    <nav-user-org-page/>

    <div class="page-container_pcr">

      <h3 class="oam_inner-title">Отчет об операциях с объектами</h3>

      <div class="oam_filter_oaf">
        <div class="oaf_cells oaf_cells-1">
          <div class="oaf_cell">
            <org-admin-dates
              :date-start.sync="filter.dateStart"
              :date-end.sync="filter.dateEnd"/>
          </div>
        </div>
        <div class="oaf_cells oaf_cells-2">
          <div class="oaf_cell">
            <org-admin-obj-types :obj-types.sync="filter.types"/>
          </div>
          <div class="oaf_cell">
            <org-admin-obj-events :obj-events.sync="filter.events"/>
          </div>
        </div>
        <div class="oaf_cells oaf_cells-2">
          <div class="oaf_cell">
            <org-admin-objs :obj-ids.sync="filter.objects"/>
          </div>
          <div class="oaf_cell">
            <org-admin-users :user-ids.sync="filter.users"/>
          </div>
        </div>
        <div class="oaf_submits">
          <button class="vivid-button" @click="fetchData">
            Сформировать отчет</button>
          <button class="trans-btn" @click="clearReportForm">
            Очистить</button>
        </div>
      </div>

      <div class="oam_cols">
        <div class="oam_col">
          <org-admin-sum
            firstTitle="Операций с объектами"
            v-if="summaryEvents && summaryEvents.length"
            :data="summaryEvents"/>
        </div>
        <div class="oam_col">
          <org-admin-sum
            firstTitle="Объектов"
            v-if="summaryTypes && summaryTypes.length"
            :data="summaryTypes"/>
        </div>
      </div>

    </div>

    <div class="page-container_pcr pcr--xl">

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="fetchData"
        layout="prev, pager, next, jumper"/>

      <div class="data-table_dta" v-if="tableData && tableData.length">
        <table>
          <thead>
            <tr>
              <th>№</th>
              <th>Дата операции</th>
              <th>Вид операции</th>
              <th>Инициатор операции / Пользователь</th>
              <th>Объект</th>
              <th>Тип объекта</th>
              <th>IPC код</th>
              <th>Зарег. авторы</th>
              <th>Незарег. авторы</th>
              <th>Организации</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(o, i) in tableData" :key="`row-${i}`">
              <td class="text-center">{{ ((pager.curPage - 1 ) * pager.pageSize) + i + 1 }}</td>
              <td class="text-center">{{ timeToDate(o.Timestamp) }}</td>
              <td>{{ o.EventTitle }}</td>
              <td>{{ o.CreatorFio }}</td>
              <td><a :href="`/object/${o.ObjectId}`" target="_blank">
                {{ o.ObjectTitle }}</a></td>
              <td>{{ o.ObjectTypeName }}</td>
              <td><a :href="`/object/${o.ObjectId}/certificate`"
                  target="_blank">{{ o.ObjectId }}</a>
              </td>
              <td>
                <a v-for="(el, i) in o.RegistratedAuthors"
                  :key="`reg-auths-${i}`"
                  :href="`/user/${el.UserId}/profile/view`"
                  target="_blank"
                  class="dta_cell-row">
                  {{ el.Fio }}
                </a>
              </td>
              <td><div v-for="(el, i) in o.UnregistratedAuthors"
                :key="`unreg-auths-${i}`">{{ el.Fio }}</div>
              </td>
              <td><div v-for="(el, i) in o.Organizations"
                :key="`orgs-${i}`">{{ el.Organization }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="fetchData"
        layout="prev, pager, next, jumper"/>

    </div>

    <div class="oam_vault" v-if="tableData && tableData.length && vaultText">
      <div class="page-container_pcr">
        <div class="oam_doc-lnk" @click="print('pdf')">
          <img src="/static/grx/icons/docs/pdf.svg" class="oam_doc-lnk-icon">
          <div class="oam_doc-lnk-txt">Скачать в формате PDF</div>
        </div>
        <div class="oam_doc-lnk" @click="print('xls')">
          <img src="/static/grx/icons/docs/xls.svg" class="oam_doc-lnk-icon">
          <div class="oam_doc-lnk-txt">Скачать в формате XLS</div>
        </div>
        <div class="oam_vault-info">
          {{ vaultText }}
        </div>
      </div>
    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import OrgAdminLayoutMixin from '@/components/layouts/org-admin/UserOrgLayoutMixin';

export default {

  mixins: [OrgAdminLayoutMixin],

  data() {
    return {
      summaryEvents: [],
      summaryTypes: [],
      reportsTotal: 3,
      filterDefaults: {
        dateStart: '',
        dateEnd: '',
        types: [],
        events: [],
        objects: [],
        users: [],
        limit: 20,
        offset: 0,
      },
    };
  },

  methods: {

    fetchData() {
      const orgId = this.$route.params.orgId;
      if (!orgId) {
        this.$notify.error('Не удалось определить организацию.');
        return;
      }
      this.reportsLoaded = 0;
      Vue.$loading.on();
      const params = this.getParams();
      axios.post(`/organizations/${orgId}/objects/events/summary`, params).then((r) => {
        this.summaryEvents = r.data;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении общей статистики объектов.');
      });
      axios.post(`/organizations/${orgId}/objects/types/summary`, params).then((r) => {
        this.summaryTypes = r.data;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении общей статистики по типам объектов.');
      });
      this.activeRequest = {
        dataKey: 'ObjectsEvents',
        url: `organizations/${orgId}/objects/events`,
        params,
      };
      axios.post(this.activeRequest.url, this.activeRequest.params).then((r) => {
        this.tableData = r.data.ObjectsEvents;
        this.pager.total = r.data.Found;
        this.vaultText = `Данные сгенерированны системой IPUniversity ${r.data.ResponseTime}`;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.tableData = [];
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении данных операций с объектами.');
      });
    },

  },

};
</script>

<style lang="scss">
@import "../../../styles/components/org-admin/common";
</style>



// WEBPACK FOOTER //
// src/components/layouts/org-admin/UserOrgObjects.vue